import { useContext } from 'react';
import styles from './Card.module.css';
import { useTranslation } from 'react-i18next';
import { TabContext } from '../../../../../Context/TabContext';
import Indicator from '../../../../UI/Indicator/Indicator';
import { formatDateFromDB } from '../../../../../../utils/FormatDate';

const Card = ({
  machine,
  handleOpenDetalView,
  handleIzmeni,
  handleDelete,
  handleDodajDelove,
  handleOpenDocumentView,
  handleOpenDnevnik,
  handleOpenTestiranje,
  handleOpenCiklusi,
}) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const handleNewService = (item) => {
    const tab = {
      title: 'Novi zahtev za servis',
      icon: 'fas fa-toolbox',
      type: 10010,
      data: item,
    };
    addTab(tab);
  };
  const handleOrderOverview = (item) => {
    const tab = {
      title: 'Naručeni delovi',
      icon: 'fas fa-toolbox',
      type: 10021,
      data: item,
    };
    addTab(tab);
  };

  return (
    <div className={styles.card} onClick={handleOpenDetalView}>
      <Indicator
        outerStyle={{ height: '28px', width: '28px' }}
        innerStyle={{}}
        status={machine.status}
        active={machine.status === 'Operativna'}
      />
      <img src={machine.slikaUrl} alt="Machine" className={styles.image} />
      <h2>{machine.sifra}</h2>
      <p>
        {t('internTag')} {machine.oznakaKupac}
      </p>
      <p>
        {t('machineType')}: {machine.tipMasine}
      </p>
      {/* <p>
        {`${machine.tipMasine === 'Robot' ? t('Robot') : t('Alat')} ${t(
          'tag',
        )}:`}{' '}
        {machine.sifra}
      </p> */}
      <p>
        {t('endOfWarrany')}: {formatDateFromDB(machine.garancijaIstice)}
      </p>
      <div className={styles.buttons}>
        <button
          onClick={(e) => handleIzmeni(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-edit ${styles.icon}`} />
          {`${t('buttons.Edit')} ${
            machine.tipMasine === 'Robot' ? t('robota') : t('alata')
          }`}
        </button>
        <button
          onClick={(e) => handleDodajDelove(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-cog ${styles.icon}`} />
          {t('addParts')}
        </button>
        <button
          onClick={() => handleNewService(machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-plus ${styles.icon}`} />
          {t('newServiceRequest')}
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleOpenDocumentView();
          }}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-file ${styles.icon}`} />
          {t('documentation')}
        </button>
        <button
          onClick={() => handleOrderOverview(machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-list-alt ${styles.icon}`} />
          {t('orderOverview')}
        </button>
        <button
          onClick={(e) => handleDelete(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-trash-alt ${styles.icon}`} />
          {`${t('buttons.delete')} ${
            machine.tipMasine === 'Robot' ? t('robota') : t('alat')
          }`}
        </button>
        <button
          onClick={(e) => handleOpenDnevnik(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-list-alt ${styles.icon}`} />
          {t('dnevnik')}
        </button>{' '}
        <button
          onClick={(e) => handleOpenTestiranje(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-check ${styles.icon}`} />
          {t('testing')}
        </button>{' '}
        <button
          onClick={(e) => handleOpenCiklusi(e, machine)}
          className={styles.buttonSecondary}
        >
          <i className={`fas fa-circle-notch ${styles.icon}`} />
          {t('cycles')}
        </button>
      </div>
    </div>
  );
};

export default Card;
